module.exports = __webpack_public_path__ + "static/media/White_with_Name.dc695a3e.png";